<template>
    <div v-if="is_initialized"
        class="content"
        :class="{
            is_showed_jobs: desc_ordered_jobs.length,
            'z-depth-3': is_modal
        }"
        :style="{
            color: theme.color.font,
            background: theme.background,
            backgroundSize: (theme.color.background_img) ? 'cover': '',
        }">
        <div>
            <WebAudio :channel="'provider_scanner_web_audio'" :allow_overlay_play="false" :show_demo="false"></WebAudio>
            <!-- 掃描input + 設定區 -->
            <Dashboard
                :is_processing="is_processing"
                :current_number="current_number"
                :current_scan_action_prototype="current_scan_action_prototype">
            </Dashboard>

            <Settings
                v-if="current_store.is_setting"
                :current_scan_action_prototype="current_scan_action_prototype"
                :is_processing="is_processing">
            </Settings>

            <!-- 運單區 堆疊 一般 都在此 -->
            <div class="scrolling content">
                <CoreWaybill
                    :is_inverted="is_modal_opened"
                    :is_modal_opened="is_modal_opened">
                </CoreWaybill>
            </div>

            <div
                style="position: absolute; right: 6px; bottom: 120px; color: red;"
                v-if="desc_ordered_jobs.length >= 3"
                @click="$store.dispatch('provider/scanner_module/clear_job')"
                class="ui jobs pointer">
                <!-- 清除紀錄 -->
                {{ $t('ui.scanner.jobs.clear_jobs') }}
            </div>
        </div>

        <transition-group class="ui list jobs" name="list" tag="div" v-if="desc_ordered_jobs.length">
            <div class="item" v-for="job in desc_ordered_jobs" :key="job.id">
                <i class="wait icon"
                    style="width: 18px;"
                    :class="{
                        'green check': job.status == 'Success',
                        'red cancel': job.status == 'Failure',
                        'orange hourglass end': job.status == 'Processing',
                        'white wait': job.status == 'Pending'
                    }">
                </i>
                <div class="content">
                    <div class="header">
                        <span v-if="job.status == 'Pending'" style="color: lightgray;">
                            <span v-if="job.is_waiting_user_action">
                                <!-- 等待使用者動作 -->
                                {{ $t('ui.scanner.jobs.waiting_user_action') }}
                            </span>
                            <span v-else>
                                <!-- 閒置中 -->
                                {{ $t('ui.scanner.jobs.idle') }}
                            </span>
                        </span>
                        <span v-else-if="job.status == 'Processing'" style="color: orange;">
                            <!-- 處理中 -->
                            {{ $t('ui.scanner.jobs.processing') }}
                        </span>
                        <span v-else-if="job.status == 'Success'" style="color: green;">
                            <!-- 成功 -->
                            {{ $t('ui.scanner.jobs.success') }}
                        </span>
                        <span v-else-if="job.status == 'Failure'" style="color: red;">
                            <!-- 失敗 -->
                            {{ $t('ui.scanner.jobs.failure') }}
                        </span>
                        <!-- 工作#{{ job.id }}：號碼 {{ job.number }} -->
                        {{ $t('ui.scanner.jobs.job') }}#{{ job.id }}：{{ $t('ui.scanner.jobs.number') }} {{ job.number }}

                        <span v-if="job.core_waybill_scope == 'original_number'">
                            [{{ $t('ui.scanner.jobs.scope.original_number') }}]
                        </span>
                        <span v-if="job.core_waybill_scope == 'new'">
                            [{{ $t('ui.scanner.jobs.scope.new') }}]
                        </span>
                        <span v-if="job.core_waybill_scope == 'fake'">
                            [{{ $t('ui.scanner.jobs.scope.fake') }}]
                        </span>
                        <span v-if="job.task == 'operation'">
                            （{{ job.scan_action_prototype.name }}）
                        </span>

                        <span v-if="job.is_batch_mode">
                            <!-- (批量作業模式) -->
                            ({{ $t('ui.scanner.settings.is_scan_action_mode.true') }})
                        </span>

                        <span v-if="job.is_waiting_instantiate_scan_action">
                            <i class="icon" :class="{
                                'green check': job.current_core_waybill_counter >= job.core_waybill_pieces,
                                'red exclamation triangle': job.current_core_waybill_counter < job.core_waybill_pieces
                            }"></i>
                            {{ job.current_core_waybill_counter }} /
                            {{ job.core_waybill_pieces }}
                            <span v-if="job.current_core_waybill_counter < job.core_waybill_pieces">
                                <!-- (尚未新增貨況) -->
                                ({{ $t('ui.scanner.jobs.no_add_status') }})
                            </span>
                        </span>
                        <span v-if="get_webcam_snaps_by_job_id(job.id).length > 0">
                            <span class="ui gray label" style="font-size: .4rem;" v-if="get_webcam_snaps_count_by_status(get_webcam_snaps_by_job_id(job.id), 'Pending') > 0">圖片閒置中({{ get_webcam_snaps_count_by_status(get_webcam_snaps_by_job_id(job.id), "Pending") }})</span>
                            <span class="ui orange label" style="font-size: .4rem;" v-if="get_webcam_snaps_count_by_status(get_webcam_snaps_by_job_id(job.id), 'Processing') > 0">圖片上傳中({{ get_webcam_snaps_count_by_status(get_webcam_snaps_by_job_id(job.id), "Processing") }})</span>
                            <span class="ui green label" style="font-size: .4rem;" v-if="get_webcam_snaps_count_by_status(get_webcam_snaps_by_job_id(job.id), 'Success') > 0">圖片上傳成功({{ get_webcam_snaps_count_by_status(get_webcam_snaps_by_job_id(job.id), "Success") }})</span>
                            <span class="ui red label" style="font-size: .4rem;" v-if="get_webcam_snaps_count_by_status(get_webcam_snaps_by_job_id(job.id), 'Error') > 0">圖片上傳錯誤({{ get_webcam_snaps_count_by_status(get_webcam_snaps_by_job_id(job.id), "Error") }})</span>
                            <span class="ui black label" style="font-size: .4rem;" v-if="get_webcam_snaps_count_by_status(get_webcam_snaps_by_job_id(job.id), 'Failure') > 0">圖片上傳失敗({{ get_webcam_snaps_count_by_status(get_webcam_snaps_by_job_id(job.id), "Failure") }})</span>
                        </span>
                    </div>
                    <div class="description">
                        <p v-for="error in job.errors" v-if="job.errors.length > 0">
                            <i class="icon red exclamation triangle"></i>
                            {{ error }}
                        </p>
                        <p v-else>
                            <!-- 無錯誤 -->
                            {{ $t('ui.scanner.jobs.no_error') }}
                        </p>
                    </div>
                </div>
            </div>
        </transition-group>

        <!-- 運單必填欄位 -->
        <CoreWaybillRelatedColumnsAlert
            v-show="is_show_related_columns_alert"
            :is_displayed="is_show_related_columns_alert"
            :is_modal_opened="is_modal_opened"
            >
        </CoreWaybillRelatedColumnsAlert>

        <!-- 貨況備註必填 -->
        <ScanActionDescriptionAlert
            v-show="is_show_scan_action_description_alert"
            :is_displayed="is_show_scan_action_description_alert"
            :is_modal_opened="is_modal_opened"
            >
        </ScanActionDescriptionAlert>

        <CreateCoreWaybillAlert
            v-show="is_show_create_core_waybill_alert"
            :is_displayed="is_show_create_core_waybill_alert"
            :is_modal_opened="is_modal_opened"
            >
        </CreateCoreWaybillAlert>


        <!-- 包裝確認 -->
        <!-- <Packagelert
            v-if="is_show_related_columns_alert"
            >
        </Packagelert> -->

    </div>
    <div v-else
        class="content"
        :class="{'z-depth-3': is_modal}"
        >
        <button class="big fluid ui black button" @click="init()">
            <!-- 請點擊再次初始化掃描系統 -->
            {{ $t('ui.notifications.help.please_clicked_initialize_again') }}
        </button>
    </div>
</template>

<script>
import WebAudio from "@toolbox/web_audio/main.vue"
import Settings from '../.components/provider/settings.vue'
import Dashboard from '../.components/provider/dashboard.vue'
import CoreWaybill from '../.components/provider/core_waybill.vue'
import CreateCoreWaybillAlert from '../.components/provider/alerts/create_core_waybill.vue'
import ScanActionDescriptionAlert from '../.components/provider/alerts/scan_action_description.vue'
import CoreWaybillRelatedColumnsAlert from '../.components/provider/alerts/core_waybill_related_columns.vue'

import Keyboard from '@javascripts/keyboard.js'
import WebCamera from 'webcamjs'

export default {
    name: "ScannerMain",
    props: {
        is_modal: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            is_initialized: false,
            is_modal_opened: false,
            is_input_mode: false,
            is_processing: false,
            is_quick_setting_number: false,
            is_any_error_message: false,
            is_mobile_width: false,
            current_scan_action_prototype_identity: this.fetch_current_scan_action_prototype_identity(),
            current_numbers: [],
            current_number: "",
            scan_actions: [],
            is_show_related_columns_alert: false,
            is_show_create_core_waybill_alert: false,
            is_show_scan_action_description_alert: false,
        }
    },
    watch: {
        current_setting_group(value) {
            this.$store.dispatch('provider/scanner_module/clear_distributed_to')
            if (value.barcode) {
                localStorage.setItem("scanner_current_setting_group", value.barcode)
            }
        },
        is_show_related_columns_alert(value) {
            this.$bus.$emit('toggle_is_hide_icon_toggle_scanner_modal', value)
        },
        is_show_scan_action_description_alert(value) {
            this.$bus.$emit('toggle_is_hide_icon_toggle_scanner_modal', value)
        },
        // 處理在store無法切換i18n的文字
        'language': {
            handler(value) {
                try {
                    this.cahnge_language_in_store_js_text()
                } catch (e) {
                    this.$noty.error(e)
                }
            },
            deep: true,
        }
    },
    mounted() {
        this.$bus.$off('set_modal_opened')
        this.$bus.$on('set_modal_opened', (is_modal_opened) => {
            return new Promise(resolve => {
                this.is_modal_opened = is_modal_opened
                if (is_modal_opened) {
                    if (this.current_store.settings.is_webcam_mode) {
                        WebCamera.on("error", err => {
                            this.$noty.warning(
                                this.$t("ui.scanner.errors.web_camera_error_will_close")
                            )
                            setTimeout((() => {
                                this.settings.is_webcam_mode = false
                            }), 500)
                            this.$store.commit('provider/scanner_module/clear_webcam_snap_interval')
                            WebCamera.reset()
                        })
                        WebCamera.set({
                            width: 192,
                            height: 108,
                            dest_width: 1920,
                            dest_height: 1080
                        })
                        WebCamera.set("constraints", {
                            optional: [{ minWidth: 600 }]
                        })
                        WebCamera.attach("#webcam")
                        this.$store.commit(
                            'provider/scanner_module/set_webcam_snap_interval',
                            setInterval(() => {
                                for (let pending_webcam_snap of _.filter(this.current_store.webcam_snaps, (webcam_snap) => {
                                    return webcam_snap.status == "Pending" || webcam_snap.status == "Error"
                                })) {
                                    this.$store.dispatch('provider/scanner_module/upload_webcam_snap', pending_webcam_snap);
                                }
                            }, 10000)
                        );
                    }
                } else {
                    this.$store.commit('provider/scanner_module/clear_webcam_snap_interval')
                    WebCamera.reset()
                }
                resolve()
            })
        })

        this.$bus.$off('quick_setting_number')
        this.$bus.$on('quick_setting_number', (set_number, is_noty = true, is_hide_settings_div = true) => {
            this.check_quick_setting_number(set_number, is_noty, is_hide_settings_div)
        })

        this.$bus.$off('set_current_scan_action_prototype')
        this.$bus.$on('set_current_scan_action_prototype', (identity) => {
            this.set_current_scan_action_prototype(identity)
        })

        this.$bus.$off('set_input_mode')
        this.$bus.$on('set_input_mode', (is_input_mode) => {
            return new Promise(resolve => {
                this.is_input_mode = is_input_mode
                resolve()
            })
        })

        this.$bus.$off('set_current_number')
        this.$bus.$on('set_current_number', (number) => {
            return new Promise(resolve => {
                this.current_number = number
                resolve()
            })
        })

        this.$bus.$off('enqueue')
        this.$bus.$on('enqueue', async () => {
            try {
                var numbers = (this.current_store.settings.is_batch_mode)
                    ? this.current_number.replace(/\s/g, '').split(",")
                    : [this.current_number]

                if (this.current_store.settings.is_batch_mode && numbers.length == 1) {
                    throw "is_batch_mode_true, please use multiple number"
                }


                for (let number of numbers) {
                    let task_mode = this.current_store.settings.is_scan_action_mode ? "operation" : "search"
                    if (this.current_store.settings.is_print_small_label_of_any_number_mode) {
                        task_mode = "print_label"
                    }
                    await this.$store.dispatch('provider/scanner_module/enqueue', {
                        task: task_mode,
                        number: number,
                        original_number: number,
                        station: this.$store.getters['provider/current_station'],
                        scan_action_prototype: this.current_scan_action_prototype,
                        partition: this.current_store.current_partition
                    })
                    await new Promise(resolve => {
                        this.current_number = ""
                        resolve()
                    })
                    await new Promise(resolve => {
                        this.submit()
                        resolve()
                    })
                }

            } catch (e) {
                switch (e) {
                    case "is_batch_mode_true, please use multiple number":
                        this.current_store.jobs.push({
                            id: this.current_store.jobs.slice(-1).pop() ? this.current_store.jobs.slice(-1).pop().id + 1:1,
                            task: this.current_store.settings.is_scan_action_mode ? "operation":"search",
                            number: this.current_number,
                            scan_action_prototype: this.current_scan_action_prototype,
                            status: "Failure",
                            is_waiting_user_action: false,
                            is_batch_mode: true,
                            // errors: ["批量作業下請輸入複數號碼"],
                            errors: [this.$t('ui.scanner.errors.multiple_numbers_in_batch_mode')],
                        })
                        this.current_number = ""
                        this.play_web_audio("error")
                        this.$store.dispatch('provider/scanner_module/set_local_storage_job')
                        break
                    case "quick_setting":
                        this.check_quick_setting_number(this.current_number, true)
                        this.current_number = ""
                        break
                    default:
                        console.log(e)
                }
            }
        })

        this.init()
    },
    methods: {
        async init() {
            try {
                await this.$store.dispatch('provider/scanner_module/fetch_scan_action_prototypes')
                await this.$store.dispatch('provider/scanner_module/fetch_materials')
                await this.$store.dispatch('provider/scanner_module/fetch_partitions')
                await this.set_current_scan_action_prototype(
                    this.current_scan_action_prototype_identity
                )

                await new Promise(resolve => {
                    // TODO: 暫強迫開啟 2018-04-18, 2018-06-28修改內容
                    _.forEach([
                        'is_core_waybill_pieces_mode',
                        'is_noty_audio_mode',
                        'is_operation_mode',
                        'is_speech_mode',
                    ], (value) => {
                        if (this.$store.getters['provider/scanner_module/is_can_use_setting'](value)) {
                            localStorage.setItem('scanner_'+value, true)
                        } else {
                            localStorage.setItem('scanner_'+value, false)
                        }
                    })
                    resolve()
                })

                await this.set_settings()
                await this.set_local_storage_to_store_state([
                    // "jobs", "core_waybill_counters"
                    "core_waybill_counters"
                ])
                await this.set_current_setting_group()
                await this.cahnge_language_in_store_js_text()
                await new Promise(resolve => {
                    this.is_initialized = true
                    resolve()
                })
                await new Promise(resolve => {
                    window.addEventListener('keydown', this.keydown)
                    resolve()
                })
            } catch (e) {
                console.log(e)
            }
        },
        async keydown(e) {
            if (this.is_modal_opened && this.current_store.is_keydown) {
                var keyboard = new Keyboard(e)
                if (!keyboard.meta && !keyboard.ctrl && !this.is_input_mode) {
                    if (keyboard.event.type == "keypress") {
                        switch (keyboard.key_code) {
                            case 13://ENTER
                                if (this.current_number) {
                                    await this.$bus.$emit('enqueue')
                                }
                                break
                            default:
                                this.current_number += keyboard.value
                        }
                    } else {
                        switch (keyboard.key_code) {
                            case 8://backspace
                                this.current_number = this.current_number.slice(0, -1)
                                break
                            case 13://ENTER
                                if (this.current_number) {
                                    await this.$bus.$emit('enqueue')
                                }
                                break
                            default:
                                this.current_number += keyboard.value
                        }
                    }
                }
            }
        },
        async submit() {
            for (let pending_job of _.filter(this.current_store.jobs, (job) => {
                return job.status == "Pending"
            })) {
                try {
                    await this.$store.dispatch('provider/scanner_module/perform', pending_job)
                    await new Promise(resolve => {
                        this.play_web_audio("ok")
                        resolve()
                    })
                } catch (e) {
                    var error_message = ""

                    switch (e) {
                        case "partition_not_found":
                            this.$store.commit('provider/scanner_module/update_current_job', {
                                status: "Failure"
                            })
                            // error_message = "無選擇號碼區間"
                            error_message = this.$t('ui.scanner.errors.partition_not_found')
                            this.play_web_audio("error")
                            break
                        case "quick_setting_not_found":
                            // error_message = "無此快速設定:" + this.current_number
                            this.$store.commit('provider/scanner_module/update_current_job', {
                                status: "Failure"
                            })
                            error_message = this.$t('ui.scanner.errors.setting_not_found')+": " +this.current_number
                            this.play_web_audio("error")
                            break
                        case "core_waybill_not_found":
                            // error_message = "查無單號"
                            error_message = this.$t('ui.scanner.errors.core_waybill_not_found')
                            this.$store.commit('provider/scanner_module/update_current_job', {
                                status: "Failure",
                                errors: [error_message]
                            })
                            this.play_web_audio("error")
                            break
                        case "no_input_number":
                            // error_message = "請輸入號碼"
                            this.$store.commit('provider/scanner_module/update_current_job', {
                                status: "Failure"
                            })
                            error_message = this.$t('ui.scanner.helps.write_number')
                            this.play_web_audio("error")
                            break
                        case "current_scan_action_prototype_identity":
                            // error_message = "請選定條碼狀態"
                            this.$store.commit('provider/scanner_module/update_current_job', {
                                status: "Failure"
                            })
                            error_message = this.$t('ui.scanner.helps.select_scan_action')
                            this.play_web_audio("error")
                            break
                        case "failed_to_instantiate_scan_action_prototype":
                            // error_message = "掃描動作失敗"
                            this.$store.commit('provider/scanner_module/update_current_job', {
                                status: "Failure"
                            })
                            error_message = this.$t('ui.scanner.errors.failed_to_instantiate_scan_action_prototype')
                            this.play_web_audio("error")
                            break
                        case "failed_to_update_core_waybill_related_column":
                            // error_message = "更新運單必要欄位失敗:"+this.current_number
                            this.$store.commit('provider/scanner_module/update_current_job', {
                                status: "Failure"
                            })
                            error_message = this.$t('ui.scanner.errors.failed_to_update_core_waybill_related_column')+": " +this.current_number
                            this.play_web_audio("error")
                            break
                        case "failed_to_fetch_core_waybill_statuses":
                            // error_message = "查詢貨況資訊失敗
                            error_message = this.$t('ui.scanner.errors.failed_to_fetch_core_waybill_statuses')
                            this.play_web_audio("error")
                            break
                        case "failed_to_create_core_waybill":
                            this.$store.commit('provider/scanner_module/update_current_job', {
                                status: "Failure"
                            })
                            error_message = "Failed to create CoreWaybill"
                            this.play_web_audio("error")
                            break
                        case "current_partition_not_set":
                            this.$store.commit('provider/scanner_module/update_current_job', {
                                status: "Failure"
                            })
                            error_message = "請選擇號碼區間"
                            this.play_web_audio("error")
                            break
                        case "core_waybill_related_column_is_empty":
                            this.$store.commit('provider/scanner_module/update_current_job', {
                                status: "Pending",
                                is_waiting_user_action: true
                            })
                            this.is_show_related_columns_alert = true
                            this.play_web_audio("alert")
                            break
                        case "scan_action_description_is_empty":
                            this.$store.commit('provider/scanner_module/update_current_job', {
                                status: "Pending",
                                is_waiting_user_action: true
                            })
                            this.is_show_scan_action_description_alert = true
                            this.play_web_audio("alert")
                            break
                        case "create_core_waybill":
                            this.$store.commit('provider/scanner_module/update_current_job', {
                                status: "Pending",
                                is_waiting_user_action: true
                            })
                            this.is_show_create_core_waybill_alert = true
                            this.play_web_audio("alert")
                            break

                        default:
                            // error_message = "運單號碼：" + this.current_number + ", " + e
                            this.$store.commit('provider/scanner_module/update_current_job', {
                                status: "Failure"
                            })
                            error_message = this.$t('models.attributes.core_waybills.number') + this.current_number + ", " + e
                            this.play_web_audio("error")
                            break
                    }

                    if (error_message) {
                        this.$noty.error(error_message, 1200)
                    }
                }
            }
        },
        set_settings() {
            this.current_store.settings = {
                is_scan_mode: this.get_setting("is_scan_mode"),
                is_speech_mode: this.get_setting("is_speech_mode"),
                is_batch_mode: this.get_setting("is_batch_mode"),
                is_operation_mode: this.get_setting("is_operation_mode"),
                is_noty_audio_mode: this.get_setting("is_noty_audio_mode"),
                is_scan_action_mode: this.get_setting("is_scan_action_mode"),
                is_distributed_to_mode: this.get_setting("is_distributed_to_mode"),
                is_high_performance_mode: this.get_setting("is_high_performance_mode"),
                is_auto_print_label_mode: this.get_setting("is_auto_print_label_mode"),
                is_print_small_label_of_any_number_mode: this.get_setting("is_print_small_label_of_any_number_mode"),
                is_reload_core_waybill_mode: this.get_setting("is_reload_core_waybill_mode"),
                is_update_core_waybill_mode: this.get_setting("is_update_core_waybill_mode"),
                is_core_waybill_pieces_mode: this.get_setting("is_core_waybill_pieces_mode"),
                is_quick_corewaybill_related_columns_mode: this.get_setting("is_quick_corewaybill_related_columns_mode"),
                core_waybill_template_mode: this.fetch_setting_use_string("core_waybill_template_mode", "card"),

                is_package_mode: this.get_setting("is_package_mode"),
                is_unpackage_mode: this.get_setting("is_unpackage_mode"),
                is_core_waybill_creation_mode: this.get_setting("is_core_waybill_creation_mode"),
                is_webcam_mode: this.get_setting("is_webcam_mode"),
                is_pack_need_source_mode: this.get_setting("is_pack_need_source_mode"),
                is_pack_need_merge_mode: this.get_setting("is_pack_need_merge_mode"),
                pack_target_parent_mode: this.fetch_setting_use_string("pack_target_parent_mode"),
                pack_target_mode: this.fetch_setting_use_string("pack_target_mode"),
            }
            return Promise.resolve()
        },
        set_local_storage_to_store_state(array = []) {
            if (array.length) {
                _.forEach(array, (value) => {
                    var result = localStorage.getItem("scanner_"+value)
                    if (result) {
                        // is String to Array Json
                        result = $.parseJSON('[' + result + ']')

                        if (value == "jobs") {
                            _.map(result, (item) => {
                                if (item.is_waiting_user_action || item.status == 'Processing') {
                                    item.is_waiting_user_action = false
                                    item.status = "Failure"
                                }
                            })
                        }
                        this.current_store[value] = result
                    }
                })
            }
            return Promise.resolve()
        },
        set_current_setting_group() {
            var setting_group_local_torage_barcode =
                this.fetch_setting_use_string("current_setting_group", "search")

            this.current_store.current_setting_group =
                _.find(this.current_store.setting_groups, (setting_group) => {
                    return setting_group.barcode == setting_group_local_torage_barcode
                }) || {}

            return Promise.resolve()
        },
        get_webcam_snaps_by_job_id(job_id) {
            return _.filter(this.current_store.webcam_snaps, function(webcam_snap) {
                return webcam_snap.job_id == job_id
            })
        },
        get_webcam_snaps_count_by_status(webcam_snaps, status) {
            return _.filter(webcam_snaps, function(webcam_snap) {
                return webcam_snap.status == status
            }).length
        },
        /*
         * ========================================================================
         * For alerts use
         * ========================================================================
         */
        async alert_failure(error_message = null) {
            this.is_show_related_columns_alert = false
            this.is_show_create_core_waybill_alert = false
            this.is_show_scan_action_description_alert = false

            if (error_message) {
                this.current_store.current_job.errors.push(error_message)
            }
            this.current_store.current_job.is_waiting_user_action = false
            this.current_store.current_job.status = "Failure"
            this.play_web_audio("error")
            this.$store.dispatch('provider/scanner_module/set_local_storage_job')
        },
        async alert_success() {
            this.is_show_related_columns_alert = false
            this.is_show_create_core_waybill_alert = false
            this.is_show_scan_action_description_alert = false
            this.current_store.current_job.is_waiting_user_action = false

            this.submit()
        },
        /**
         * ========================================================================
         * Event bus Scanning run
         * ========================================================================
        **/
        toggle_settings_div(boolean = null) {
            if (boolean == null) {
                this.current_store.is_setting =
                    !this.current_store.is_setting
            } else if (typeof(boolean) == 'boolean'){
                this.current_store.is_setting = boolean
            }
        },
        check_quick_setting_number(number, is_noty = true, is_hide_settings_div = true) {
            // 全部快速設定
            var is_quick_setting_number_result = false
            var is_setting_group = number.match(this.quick_setting_regexps.group)
            var is_barcode_number = number.match(this.quick_setting_regexps.barcode)
            var is_setting_mode = number.match(this.quick_setting_regexps.mode)
            var is_package_setting = number.match(this.quick_setting_regexps.package)

            // 設定包 條碼+細部設定
            if (is_setting_group) {
                try {
                    var barcode_name = is_setting_group[1]
                    var setting_group = _.findLast(this.current_store.setting_groups, (setting) => {
                        return setting.key == barcode_name
                    })
                    // if (!setting_group) throw "無此快速設定包"
                    if (!setting_group) throw this.$t('ui.scanner.errors.setting_group_not_found')
                    var barcode_string = "", setting_string = ""

                    // 隱藏設定區塊
                    if (is_hide_settings_div) {
                        this.toggle_settings_div(false)
                    }

                    // 設定 setting_group
                    this.set_current_store_setting_group(setting_group.barcode)

                    // 此設定包是 scan_action 才改變選定條碼狀態
                    if (setting_group.is_scan_action) {
                        barcode_string = "####"+setting_group.barcode+"####"
                        if (!this.quick_setting_barcode(
                            barcode_string.match(this.quick_setting_regexps.barcode)
                        )) {
                            // this.$noty.error("無此快速設定："+setting_group.barcode, 1200)
                            this.$noty.error(
                                this.$t('ui.scanner.errors.setting_not_found') + "： "+
                                setting_group.barcode
                            , 1200)
                        } else {
                            is_quick_setting_number_result = true
                        }
                    }

                    // 細部設定
                    if (setting_group.settings) {
                        _.forEach(setting_group.settings, (setting) => {
                            setting_string = "##"+setting+"##"
                            if (!this.quick_setting_mode(
                                setting_string.match(this.quick_setting_regexps.mode)
                            )) {
                                // this.$noty.error("無此快速設定："+setting, 1200)
                                this.$noty.error(
                                    this.$t('ui.scanner.errors.setting_not_found') + "： "+
                                    setting
                                , 1200)
                            } else {
                                is_quick_setting_number_result = true
                            }
                        })
                    }
                } catch (error) {
                    this.$noty.error(error)
                }
            }

            // 條碼
            if (is_barcode_number) {
                if (!this.quick_setting_barcode(is_barcode_number)) {
                    // this.$noty.error("無此快速設定："+is_barcode_number, 1200)
                    this.$noty.error(
                        this.$t('ui.scanner.errors.setting_not_found') + "： "+
                        is_barcode_number
                    , 1200)
                } else {
                    is_quick_setting_number_result = true
                }
            }

            // 掃描細部設定
            if (is_setting_mode) {
                if (!this.quick_setting_mode(is_setting_mode)) {
                    // this.$noty.error("無此快速設定："+is_setting_mode, 1200)
                    this.$noty.error(
                        this.$t('ui.scanner.errors.setting_not_found') + "： "+
                        is_setting_mode
                    , 1200)
                } else {
                    is_quick_setting_number_result = true
                }
            }

            // 包裝進階設定 A包B 並看尾數10 第一個數字：套用資料 第二個數字：合併資料
            if (is_package_setting) {
                if (!this.quick_package_setting(is_package_setting)) {
                    // this.$noty.error("無此快速設定："+is_setting_mode, 1200)
                    this.$noty.error(
                        this.$t('ui.scanner.errors.setting_not_found') + "： "+
                        number
                    , 1200)
                } else {
                    is_quick_setting_number_result = true
                }
            }

            if (is_quick_setting_number_result && is_noty) {
                // this.$noty.success('快速設定成功')
                this.$noty.success(
                    this.$t('ui.scanner.success.quick_setting')
                )
                this.is_quick_setting_number = is_quick_setting_number_result
            }

            return Promise.resolve()
        },
        quick_setting_barcode(match_result) {
            var result = _.find(this.current_store.scan_action_prototypes, (scan_action_prototype) => {
                if (scan_action_prototype.barcode == match_result[1]) {
                    return true
                } else if (scan_action_prototype.barcode == match_result[2]) {
                    return true
                } else {
                    return false
                }
                return false
            })

            if (result != undefined) {
                this.current_store.current_scan_action_prototype = result
                localStorage.setItem('current_scan_action_prototype_identity', result.identity)

                // 清空當前 運單
                this.current_store.current_core_waybill = {}
                return true

            } else {
                return false
            }
        },
        quick_setting_mode(match_result) {
            var mode_name = match_result[1]

            var mode_sesult = match_result[2]
            if (match_result[2] === 'true') mode_sesult = true
            if (match_result[2] === 'false') mode_sesult = false

            if (this.settings[mode_name] != undefined) {
                if (this.$store.getters['provider/scanner_module/is_can_use_setting'](mode_name)) {
                    this.current_store.settings[mode_name] = mode_sesult
                    localStorage.setItem('scanner_'+mode_name, mode_sesult)
                } else {
                    this.current_store.settings[mode_name] = false
                }
                return true

            } else {
                return false
            }
        },
        quick_package_setting(match_result) {
            // 不可使用包裝設定者 直接跳出
            if (this.$store.getters['provider/scanner_module/is_can_use_setting']('is_package_mode')) {
                this.check_quick_setting_number("@@package@@", false) //切換至包裝設定 並不跳通知
                let packing_material = match_result[1] // 包裝者
                let pack_taget = match_result[2] // 包裝目標
                let is_pack_need_source_mode  = match_result[3] // 套用資料
                let is_pack_need_merge_mode = match_result[4] // 合併資料

                this.current_store.settings.is_pack_need_source_mode = (is_pack_need_source_mode === '1') ? true : false
                this.current_store.settings.is_pack_need_merge_mode = (is_pack_need_merge_mode === '1') ? true : false

                // ###Waybill_to_Waybill_00###
                // ###House_to_Package_10###
                // ###Package_to_Waybill_11###
                // ###Master_to_Goods_01###
                if (this.current_store.materials) {
                    setTimeout((() => {
                        let packing_material_result = _.findLast(this.current_store.materials, (material) => {
                            return material.class_name == packing_material
                        })
                        if (packing_material_result) {
                            this.current_store.current_pack_taget_parent_material_identity = packing_material_result.identity
                        } else {
                            // "請選定包材"
                            this.$noty.error(this.$t('ui.scanner.helps.select_pack_taget_parent'))
                        }
                        this.$forceUpdate()
                        setTimeout((() => {
                            let pack_taget_result = _.findLast(this.current_store.materials, (material) => {
                                return material.class_name == pack_taget
                            })
                            if (pack_taget_result) {
                                this.current_store.current_pack_taget_material_identity = pack_taget_result.identity
                            } else {
                                // "請選包裝目標"
                                this.$noty.error(this.$t('ui.scanner.helps.select_pack_taget'))
                            }
                            this.$forceUpdate()
                        }), 300)
                    }), 300)
                }
                return true
            } else {
                return false
            }
        },
        set_current_store_setting_group(setting_group_barcode) {
            this.current_store.current_setting_group =
                _.find(this.current_store.setting_groups, (setting_group) => {
                    return setting_group.barcode == setting_group_barcode
                })
        },

        /**
         * ========================================================================
         * Event bus Settings run
         * ========================================================================
        **/
        set_current_scan_action_prototype(identity = null) {
            var result = _.find(this.current_store.scan_action_prototypes, (scan_action_prototype) => {
                return scan_action_prototype.identity == identity
            })

            if (result != undefined) {
                this.current_store.current_scan_action_prototype  = result
                localStorage.setItem('current_scan_action_prototype_identity', result.identity)
            }
        },

        /**
         * ========================================================================
         * Vue data function
         * ========================================================================
        **/
        get_setting(string = "") {
            var name = `scanner_${string}`
            var reslut = localStorage.getItem(name)

            if (reslut == null) {
                localStorage.setItem(name, false)
                return false
            }
            if (reslut == 'true') {
                return true
            } else {
                return false
            }
        },
        fetch_setting_use_string(string = "", default_value = "") {
            var name = `scanner_${string}`
            var reslut = localStorage.getItem(name)

            if (reslut == null) {
                localStorage.setItem(name, default_value)
                return default_value
            }
            return localStorage.getItem(name)
        },
        fetch_current_scan_action_prototype_identity() {
            var name = "current_scan_action_prototype_identity"
            var reslut = localStorage.getItem(name)

            if (reslut == null || reslut == "") {
                localStorage.setItem(name, "")
                return null
            } else {
                return localStorage.getItem(name)
            }
       },

        /**
         * ========================================================================
         * Elements run
         * ========================================================================
        **/


        /**
         * ========================================================================
         * WebAudio
         * ========================================================================
        **/
        play_web_audio(value = null) {
            if (this.settings.is_noty_audio_mode) {
                switch (value) {
                    case 'ok':
                    case 'alert':
                    case 'error':
                        this.$bus.$emit('provider_scanner_web_audio', 'play_sound', value)
                        break
                    default:
                        this.$bus.$emit('provider_scanner_web_audio', 'play_sound', "error")
                        break
                }
            }
        },
        /**
         * ========================================================================
         * 處理在store無法切換i18n的文字
         * ========================================================================
        **/
        cahnge_language_in_store_js_text() {
            _.map(this.setting_groups, (setting_group) => {
                if (setting_group.i18n_key) {
                    setting_group.name = this.$t(setting_group.i18n_key)
                }
            })

            return Promise.resolve()
        },
    },
    computed: {
        language() {
            return this.$store.state.language
        },
        current_store() {
            return this.$store.state.provider.scanner_module
        },
        theme() {
            return this.current_store.config.theme
        },
        quick_setting_regexps() {
            return this.current_store.quick_setting_regexps
        },
        settings() {
            return this.current_store.settings
        },
        setting_groups() {
            return this.current_store.setting_groups
        },
        current_setting_group() {
            return this.current_store.current_setting_group
        },
        core_waybills() {
            return this.current_store.core_waybills
        },
        current_core_waybill() {
            return this.current_store.current_core_waybill
        },
        error_messages() {
            return this.current_store.error_messages
        },
        desc_ordered_jobs() {
            return _.orderBy(this.current_store.jobs, 'id', 'desc')
        },
        current_scan_action_prototype() {
            return this.current_store.current_scan_action_prototype
        },
    },
    components: {
        WebAudio,
        Settings,
        Dashboard,
        CoreWaybill,
        CreateCoreWaybillAlert,
        ScanActionDescriptionAlert,
        CoreWaybillRelatedColumnsAlert,
    },
}
</script>

<style scoped lang="scss">

.ui.list.jobs {
    & {
        position: absolute;
        bottom: 0;
        width: 100%;
        margin-top: 0 !important;
        max-height:100px;
        overflow: auto;
        border-top: 1px solid lightgray;
        padding: 10px;
    }
    .header {
        color: white;
    }
    .description {
        color: white;
    }
}
@media only screen and (max-width: 767px) {
    .ui.list.jobs {
        & {
            padding-right: 30px;
        }
        .item {
            font-size: 12px;
            .description {
                padding: 1px !important
            }
        }
    }
}
// @import "../.assets/stylesheets/layout.scss";
.ui.modal.scanner > .content {
    & {
        padding: 0 !important;
        // overflow: inherit;
    }
    &.is_showed_jobs {
        padding-bottom: 100px !important;
    }
    .ui.container {
        width: 100%;
        // margin: 0 !important;
        border-radius: 6px;
    }
    .scrolling {
        overflow-x: hidden;
        padding-bottom: 30px;
    }
}
@media only screen and (min-width: 767px) {
    .ui.modal.scanner > .content .scrolling {
        padding-left: 30px;
        padding-right: 30px;
    }
}
// for HoneyWell
@media only screen and (max-height: 550px) {
    .ui.modal.scanner > .content .scrolling {
        max-height: 320px;
    }
}
</style>
